import { useCurrentWorkspace } from "@accurx/auth";
import { Ds } from "@accurx/design";
import { Log } from "@accurx/shared";
import { useInboxParams } from "domains/inbox/hooks/util";
import { ROUTES_INBOX } from "domains/inbox/routes";
import { Redirect, generatePath } from "react-router-dom";

import { ComposeAreaVisibilityProvider } from "../../../ConversationView/ComposeAreaVisibilityContext/ComposeAreaVisibilityProvider";
import {
    ComposableConversationArea,
    ConversationLoader,
} from "../../../ConversationView/ConversationView";
import { AssigneeSelectorButton } from "./AssigneeSelectorButton";
import {
    StyledActionsContainer,
    StyledChip,
    StyledInnerActionsContainer,
} from "./ConversationPage.styles";

export const ConversationPage = () => {
    const { conversationId } = useInboxParams(["conversationId"]);
    const workspaceId = useCurrentWorkspace().orgId;

    if (!conversationId) {
        Log.error(
            "User attempted to view a conversation started with a note but had no conversation ID",
        );

        const pathname = generatePath(ROUTES_INBOX.MyInbox, { workspaceId });
        return <Redirect to={pathname} />;
    }

    return (
        <ComposeAreaVisibilityProvider key={conversationId}>
            <ConversationLoader conversationId={conversationId}>
                {({ conversation }) => (
                    <ComposableConversationArea
                        conversation={conversation}
                        actions={
                            <StyledActionsContainer>
                                <StyledInnerActionsContainer justifyContent="space-between">
                                    <Ds.Flex alignItems="center">
                                        <StyledChip>
                                            <Ds.Text as="span" size="small">
                                                With: <strong>Patient</strong>
                                            </Ds.Text>
                                        </StyledChip>
                                    </Ds.Flex>
                                    <Ds.Flex.Item>
                                        <AssigneeSelectorButton
                                            conversation={conversation}
                                        />
                                    </Ds.Flex.Item>
                                </StyledInnerActionsContainer>
                            </StyledActionsContainer>
                        }
                    />
                )}
            </ConversationLoader>
        </ComposeAreaVisibilityProvider>
    );
};
